import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import getHeaders from '../../utils/authHeaders';
import { app } from '../../config';


import { Pagination, Input, Form, Select, Row, Col, Space, Spin, message, Collapse, DatePicker, Button } from 'antd';

const DashboardMainOrderModal = ({ isVisible, setIsVisible, ecomOrderId }) => {
    let totalTax = 0;

    const [isModalLoading, setIsModalLoading] = useState(false);
    const [subOrdersData, setSubOrdersData] = useState([]);
    const [mainOrderObj, setMainOrderObj] = useState({});
    const [runfunc, setRunFunc] = useState(false);
    console.log("id: ", ecomOrderId);
    console.log("headers: ", getHeaders());
    // useEffect( () => {
// if(isVisible)setRunFunc(true)
// console.log("Run Func",runfunc)
        console.log("id: ", ecomOrderId);
        console.log("headers: ", getHeaders());
    useEffect(() => {
        console.log("Dataaaa")
        const getData = async () => {
            setIsModalLoading(true);
                    let resp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view/${ecomOrderId}`, { headers: getHeaders() });
                    console.log("order data in modal effect: ", resp.data.result.data);
                    setMainOrderObj(resp.data.result.data);
                    setSubOrdersData(resp.data.result.data?.orderDetails);
                    setIsModalLoading(false);
        }
        getData()
    }, [runfunc]) 
        //const getMainOrderData = async () => {
        //     try {
        //         setIsModalLoading(true);
        //         let resp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view/${ecomOrderId}`, { headers: getHeaders() });
        //         console.log("order data in modal effect: ", resp.data.result.data);
        //         setMainOrderObj(resp.data.result.data);
        //         setSubOrdersData(resp.data.result.data?.orderDetails);
        //         setIsModalLoading(false);

        //     } catch (error) {
        //         console.log("Error: ", error)
        //     }
        // }

        // getMainOrderData();
       
    // }, []);


    return (
        <Modal show={isVisible}
            size='lg'
            onHide={() => {
                setIsVisible(!isVisible);
            }} centered>

            closeButton
            <Modal.Header
            closeButton
            closeLabel='X'
            style={{
                display: "block"
            }}>
                <Modal.Title style={{ display: "block", padding: "9px 13px 8px 8px", fontSize: "20px" }} >
                    <div className='row'>
                        <div className='col-lg-6'>{mainOrderObj?.ecomOrderNo}</div>
                        <div className='col-lg-6 text-right'>{mainOrderObj?.createdAt}</div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "0px 20px !important" }}>
                {
                    !isModalLoading ? (

                        <>
                            {/* <div className='row'>
                    <div className='col-lg-6 fs-5 mt-0 mb-0 pt-0 pb-0 pl-3'>{patientName}</div>      
                     <div className='col-lg-6 mt-0 mb-0 pt-2 pb-0 pl-3 text-right'>{shipmentTotal}</div>
                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3'>{productTotalAmount}</div>
                </div> */}


                            {/* <div className='mb-4'>
                    <table id="customers" >
                        <thead>
                            <tr>
                                <th>Sub Order No</th>
                                <th>Shipment Address</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                subOrdersData?.map((subOrder, index) => {
                                    return (
                                        <tr>

                                            <td style={{ width: '100px' }}>{`${ecomOrderNo}-${subOrder.addressId}`}</td>
                                            <td style={{ width: '100px' }}>{`${subOrder.address}, ${subOrder.state}, ${subOrder.city}, ${subOrder.zipCode}`}</td>
                                            <td style={{ width: '100px' }}>{subOrder.status}</td>
                                        </tr>
                                    )
                                })

                            }
                        </tbody>
                    </table>
                </div>

                
                <div className='row'>
                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Amount: $50</div>
                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Tax: $10</div>
                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Shipment Amount: $25 </div>
                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Grand Total: $85</div>
                </div> */}

                            {
                                subOrdersData?.map((subOrder, index) => {
                                    totalTax += Number(subOrder.taxAmount)
                                    return (
                                        <div className="p-4 mb-4" style={{
                                            border: "1px solid silver",
                                            borderRadius: 10,
                                        }}>
                                            <div className='row'>
                                                <div className='col-lg-6 fs-5 mt-0 mb-0 pt-0 pb-0 pl-3'>{subOrder.title}</div>
                                                <div className='col-lg-6 mt-0 mb-0 pt-2 pb-0 pl-3 text-right'>{subOrder.status}</div>
                                                <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3'>{subOrder.address}</div>
                                                {subOrder.requestId ? <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3' style={{textTransform:'capitalize'}}>Request Type: {subOrder.requestType}  Request Status: {subOrder.requestStatus}</div> : " "}
                                                {/* <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3'>{singleOrderOBj.status}</div>  */}
                                            </div>
                                            <div className='mb-4'>
                                                <table id="customers" >
                                                    <thead>
                                                        <tr>
                                                            <th>Product Name </th>
                                                            <th>Quantity</th>
                                                            <th>Unit Price</th>
                                                            <th>Total</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {

                                                            subOrder?.products?.map((product, index) => {
                                                                return (
                                                                    <tr>

                                                                        <td style={{ width: '100px' }}>{product.productName}</td>
                                                                        <td style={{ width: '100px' }}>{product.quantity}</td>
                                                                        <td style={{ width: '100px' }}>{product.unitPrice}</td>
                                                                        <td style={{ width: '100px' }}>{parseFloat(product.quantity) * parseFloat(product.unitPrice)}</td>

                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                                <div className='row'>
                                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Amount: ${subOrder.totalShipmentAmount}</div>
                                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Tax: ${subOrder.taxAmount.toFixed(2)}</div>
                                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Shipment Amount: ${subOrder.shipmentCharges} </div>
                                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Grand Total: ${(subOrder.totalAmountwithShipment + subOrder.taxAmount).toFixed(2)}</div>
                                                </div>

                                            </div>


                                            {/* <div className='row'>
                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Amount: ${product.totalShipmentAmount}</div>
                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Tax: ${product.taxAmount.toFixed(2)}</div>
                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Shipment Amount: ${product.shipmentCharges} </div>
                                    <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Grand Total: ${(product.totalAmountwithShipment + product.taxAmount).toFixed(2)}</div>
                                </div> */}
                                        </div>
                                    )
                                })
                            }

                            <div className='row'>

                                <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Product Amount: $ { mainOrderObj?.totalProductAmount?.toFixed(2)}</div>    
                                <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Total Tax: $ {mainOrderObj?.totalTaxAmount?.toFixed(2)}</div>
                                <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Shipment Amount: $ {mainOrderObj?.totalShipmentCharges?.toFixed(2)}</div>
                                <div className='col-lg-12  mt-0 mb-0 pt-0 pb-0 pl-3 text-right'>Grand Total: $ {(mainOrderObj?.grandTotalAmount + mainOrderObj?.totalTaxAmount).toFixed(2)}</div>

                            </div>
                        </>
                    
                    
                    ) : (
                        <div className='row text-center'>
                            <span>  <Space size="middle">
                                <Spin size="large" />
                            </Space></span>
                        </div>
                    )
                }
            </Modal.Body>
            <Modal.Footer>

                <Button variant='secondary' onClick={() => {
                    setIsVisible(!isVisible)
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DashboardMainOrderModal;